module.exports = __webpack_public_path__ + "static/media/GLGlogo.54db282d.png";